// © Microsoft Corporation. All rights reserved.
/**
 * Enum for different auth cookie names
 * @enum
 */
export var AuthCookieName;
(function (AuthCookieName) {
    AuthCookieName["Anon"] = "ANON";
    AuthCookieName["AppAnon"] = "APP_ANON";
    AuthCookieName["Unknown"] = "";
})(AuthCookieName || (AuthCookieName = {}));
/**
 * List of http-readable cookies that indicate the presence of an auth cookie
 * IMPORTANT NOTE: If this is updated, please update the list in WebWorkerInitializer.ts as well
 */
export var AuthCookieExistsCookieName;
(function (AuthCookieExistsCookieName) {
    AuthCookieExistsCookieName["AnonCookieExists"] = "ace";
    AuthCookieExistsCookieName["AppAnonCookieExists"] = "aace";
})(AuthCookieExistsCookieName || (AuthCookieExistsCookieName = {}));
/**
 * Original source is Constants.ts
 * Child cookie name, used to signal if rpsUser is child account.
 */
export const childCookieName = "child";
//# sourceMappingURL=AuthCookieNames.js.map